export class createTagDTO{
    name: string;
    description: string;
    system: boolean;
    unique: boolean;
    type: number;
}